(function () {
  // roundRect polyfill for older browsers
  if (!CanvasRenderingContext2D.prototype.roundRect) {
    CanvasRenderingContext2D.prototype.roundRect = function(x, y, width, height, radius) {
      this.beginPath();
      this.moveTo(x + radius, y);
      this.lineTo(x + width - radius, y);
      this.quadraticCurveTo(x + width, y, x + width, y + radius);
      this.lineTo(x + width, y + height - radius);
      this.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
      this.lineTo(x + radius, y + height);
      this.quadraticCurveTo(x, y + height, x, y + height - radius);
      this.lineTo(x, y + radius);
      this.quadraticCurveTo(x, y, x + radius, y);
      this.closePath();
    };
  }

  function formatMoney(cents, moneyFormat) {
    const amount = (cents / 100).toFixed(2);
    return moneyFormat.replace("{{amount}}", amount);
  }

  function sumQty(map) {
    let total = 0;
    Object.values(map).forEach((n) => (total += n));
    return total;
  }

  function ensure(el, msg) {
    if (!el) throw new Error(msg);
    return el;
  }

  function initBundleBuilder(sectionEl) {
    const sectionId = sectionEl.dataset.sectionId;
    const storageKey = `bb_selections_${sectionId}`;
    const productsJsonEl = ensure(sectionEl.querySelector("[data-bb-products]"), "Products JSON not found");
    const collectionsJsonEl = sectionEl.querySelector("script[data-bb-collections]");
    let collections = [];
    if (collectionsJsonEl && collectionsJsonEl.textContent) {
      try {
        const raw = collectionsJsonEl.textContent.trim();
        collections = raw ? JSON.parse(raw) : [];
      } catch (e) {
        console.warn("Bundle Builder: collections JSON parse failed", e);
      }
    }
    if (!Array.isArray(collections)) collections = [];
    const collectionsWraps = Array.from(sectionEl.querySelectorAll("[data-bb-collections-ui]"));
    const collectionsSelects = Array.from(sectionEl.querySelectorAll("[data-bb-collections-select]"));
    const collectionsSelect = collectionsSelects[0] || null;
    const collectionsWrap = collectionsWraps[0] || null;
    const searchInput = sectionEl.querySelector("[data-bb-search-input]");
    const searchToggle = sectionEl.querySelector("[data-bb-search-toggle]");
    const searchWrapper = sectionEl.querySelector(".bb__searchwrapper");
    const searchEl = sectionEl.querySelector("[data-bb-search]");

    const collectionsByTab = { 1: [], 2: [] };
    collections.forEach((c) => {
      const t = Number(c.tab) || 1;
      if (!collectionsByTab[t]) collectionsByTab[t] = [];
      // selectorTitle ve image gorsel secici icin; burada dusurulurse kartlar
      // koleksiyon basligina ve ikonsuz haline geri doner.
      collectionsByTab[t].push({
        handle: String(c.handle || ""),
        title: String(c.title || ""),
        selectorTitle: String(c.selectorTitle || ""),
        image: String(c.image || ""),
      });
    });

    // aynı handle birden fazla kez geldiyse tekilleştir
    [1, 2].forEach((t) => {
      const seen = new Set();
      collectionsByTab[t] = (collectionsByTab[t] || []).filter((x) => {
        if (!x.handle) return false;
        if (seen.has(x.handle)) return false;
        seen.add(x.handle);
        return true;
      });
    });

    const activeCollection = { 1: null, 2: null };
    [1, 2].forEach((t) => {
      activeCollection[t] = collectionsByTab[t]?.[0]?.handle || null;
    });

    let products = [];
    try {
      const rawProducts = (productsJsonEl.textContent || "").trim();
      products = rawProducts ? JSON.parse(rawProducts) : [];
    } catch (e) {
      console.warn("Bundle Builder: products JSON parse failed", e);
    }
    if (!Array.isArray(products)) products = [];

    /* --- koleksiyonun geri kalanini vitrinden cek -----------------------
       Liquid'in collection.products dongusu Shopify tarafinda 50 urunde
       duruyor; limit ayarini yukseltmek bir sey degistirmiyor. Bu yuzden
       Animals kategorisinde 143 patch'in 50'si, Slogans ve Letters'ta da
       yalnizca 50'si listeleniyordu - musteri katalogun ucte birini
       goruyordu. Kalanini vitrinin kendi products.json ucundan sayfa sayfa
       aliyoruz; uygulama veya ek yetki gerekmiyor. */
    async function loadRestOfCollections() {
      const jobs = [];
      [1, 2].forEach((t) => {
        (collectionsByTab[t] || []).forEach((c) => {
          if (c.handle) jobs.push({ tab: t, handle: c.handle, title: c.title });
        });
      });
      let added = 0;
      for (const job of jobs) {
        const seen = new Set(
          products.filter((p) => String(p.collectionHandle || "") === job.handle)
                  .map((p) => Number(p.productId))
        );
        for (let page = 1; page <= 6; page++) {
          let data;
          try {
            const res = await fetch(
              "/collections/" + job.handle + "/products.json?limit=250&page=" + page,
              { credentials: "omit" }
            );
            if (!res.ok) break;
            data = await res.json();
          } catch (e) {
            break;
          }
          const list = (data && data.products) || [];
          if (!list.length) break;
          list.forEach((p) => {
            if (seen.has(Number(p.id))) return;
            const v = (p.variants || [])[0];
            if (!v) return;
            seen.add(Number(p.id));
            const img = (p.images || [])[0];
            products.push({
              source: "storefront_json",
              tab: job.tab,
              productId: p.id,
              collectionHandle: job.handle,
              collectionTitle: job.title,
              productHandle: p.handle,
              title: p.title,
              variantId: v.id,
              sku: v.sku || "",
              priceCents: Math.round(parseFloat(v.price) * 100),
              compareAtPriceCents: v.compare_at_price
                ? Math.round(parseFloat(v.compare_at_price) * 100)
                : 0,
              image: img ? img.src.split("?")[0] + "?width=600" : "",
              available: v.available !== false,
              badgeHtml: "",
            });
            added++;
          });
          if (list.length < 250) break;
        }
      }
      if (added) {
        byVariantId.clear();
        products.forEach((p) => byVariantId.set(Number(p.variantId), p));
        renderGrid();
      }
      return added;
    }

    const moneyFormat = sectionEl.dataset.moneyFormat || "{{amount}}";
    const showPrices = sectionEl.dataset.showPrices !== "false";
    const showPopupPrices = sectionEl.dataset.showPopupPrices !== "false";
    const showSetTotal = sectionEl.dataset.showSetTotal !== "false";
    const showTotalPrice = sectionEl.dataset.showTotalPrice !== "false";
    /* Set fiyatini tetikleyen isaret satiri. Indirim yalniz bu satira bakiyor,
       satiri da yalniz bu kurucu sepete koyuyor - baska hicbir yerden gelmiyor.
       Bos birakilirsa kurucu hicbir indirim uygulamaz ve toplam iki urunun
       toplami olarak kalir, yani ekran ile sepet ayrisamaz.

       Neden kod degil: uygulanmis bir indirim kodu Shopify'da ziyaretcinin
       oturumuna yapisiyor - olculdu, /cart/clear.js sepeti bosaltti ama kod
       durdu ve koleksiyon sayfalarindan kurulan bir sonraki sepet de indirimli
       cikti. Sepet satiri sepetle birlikte gidiyor. */
    const SET_MARKER_VARIANT_ID = Number(sectionEl.dataset.setMarkerVariantId || 0) || 0;
    /* Isaret satirinin kendi fiyati. Sifir OLAMAZ: Shopify $0'lik bir satiri
       "musteri alir" kosulunda alisveris saymiyor ve indirim hic tetiklenmiyor -
       olculdu, $0.00'da sepet 64.80 kaldi, $0.01'de 49.91'e dustu. Bu bir sent
       toplama geri ekleniyor ki ekrandaki rakam sepetle birebir ayni olsun. */
    const SET_MARKER_CENTS = Number(sectionEl.dataset.setMarkerPriceCents || 0) || 0;
    /* Sepete ekleme sirasinda butonda gorunen metin. Kodda Turkce
       "Ekleniyor..." yaziyordu ve ABD musterisine oyle basiliyordu. */
    const ADDING_LABEL = sectionEl.dataset.addingLabel || "Adding…";

    /* Kendi tasarimini yukle. Turkiye'deki ayni ozellik bir uygulamanin kendi
       tasarim motoru; burada uygulama yok, o yuzden kurucunun zaten sahip
       oldugu parcalardan kuruluyor: "Custom Patch" siradan bir patch urunu
       olarak seritte duruyor, secilince asagida yukleme alani aciliyor ve dosya
       sepete satir ozelligi olarak gidiyor. */
    const CUSTOM_PATCH_VARIANT_ID = Number(sectionEl.dataset.customPatchVariantId || 0) || 0;
    const UPLOAD_MAX_BYTES = 8 * 1024 * 1024;
    const uploadEl = sectionEl.querySelector("[data-bb-upload]");
    const uploadInput = sectionEl.querySelector("[data-bb-upload-input]");
    const uploadFileEl = sectionEl.querySelector("[data-bb-upload-file]");
    const uploadThumb = sectionEl.querySelector("[data-bb-upload-thumb]");
    const uploadName = sectionEl.querySelector("[data-bb-upload-name]");
    const uploadClear = sectionEl.querySelector("[data-bb-upload-clear]");
    const uploadError = sectionEl.querySelector("[data-bb-upload-error]");
    let customArtFile = null;
    let customArtUrl = "";

    const rules = {
      1: { min: Number(sectionEl.dataset.tab1Min || 0), max: Number(sectionEl.dataset.tab1Max || 1) },
      2: { min: Number(sectionEl.dataset.tab2Min || 0), max: Number(sectionEl.dataset.tab2Max || 1) }
    };

    // TR'deki gibi iki panel yan yana: her sekmenin kendi izgarasi var.
    const gridEls = {};
    Array.from(sectionEl.querySelectorAll("[data-bb-grid]")).forEach((el) => {
      gridEls[Number(el.getAttribute("data-bb-panel")) || 1] = el;
    });
    const gridEl = ensure(gridEls[1], "Grid not found");
    const allGrids = Object.keys(gridEls).map((k) => gridEls[k]);
    const msgEls = Array.from(sectionEl.querySelectorAll("[data-bb-msg]"));
    ensure(msgEls.length, "Msg not found");

    const prevBtn = ensure(sectionEl.querySelector("[data-bb-prev]"), "Prev not found");
    const nextBtn = ensure(sectionEl.querySelector("[data-bb-next]"), "Next not found");
    const addBtn = ensure(sectionEl.querySelector("[data-bb-add]"), "Add not found");
    const reviewHeadEl = sectionEl.querySelector("[data-bb-mobile-toggle]");
    const reviewTitleTextEl = reviewHeadEl?.querySelector(".bb__reviewtitle-text");
    const reviewTitleIconEl = reviewHeadEl?.querySelector(".bb__reviewtitle-icon");

    const clearBtn = ensure(sectionEl.querySelector("[data-bb-clear]"), "Clear not found");

    const totalEl = sectionEl.querySelector("[data-bb-total]");
    const setTotalEl = sectionEl.querySelector("[data-bb-set-total]");
    const modalEl = sectionEl.querySelector("[data-bb-modal]");
    const modalCloseEls = sectionEl.querySelectorAll("[data-bb-modal-close]");
    const qvThumbsEl = sectionEl.querySelector("[data-bb-qv-thumbs]");
    const qvMainImgEl = sectionEl.querySelector("[data-bb-qv-mainimg]");
    const qvTitleEl = sectionEl.querySelector("[data-bb-qv-title]");
    const qvPriceEl = sectionEl.querySelector("[data-bb-qv-price]");
    const qvSkuEl = sectionEl.querySelector("[data-bb-qv-sku]");
    const qvDescEl = sectionEl.querySelector("[data-bb-qv-desc]");
    const qvPriceCompareEl = sectionEl.querySelector("[data-bb-qv-price-compare]");
    const qvLinkEl = sectionEl.querySelector("[data-bb-qv-link]");
    const qvModalmidEl = sectionEl.querySelector(".bb__modalmid");

    const tabBtns = Array.from(sectionEl.querySelectorAll(".bb__tab"));
    const tabCounts = {
      1: ensure(sectionEl.querySelector('[data-bb-count="1"]'), "Count 1 not found"),
      2: ensure(sectionEl.querySelector('[data-bb-count="2"]'), "Count 2 not found")
    };

    const pickedEls = {
      1: ensure(sectionEl.querySelector('[data-bb-picked="1"]'), "Picked 1 not found"),
      2: ensure(sectionEl.querySelector('[data-bb-picked="2"]'), "Picked 2 not found")
    };

    const reviewTabs = {
      1: ensure(sectionEl.querySelector('[data-bb-reviewtab="1"]'), "Review tab 1 not found"),
      2: ensure(sectionEl.querySelector('[data-bb-reviewtab="2"]'), "Review tab 2 not found")
    };

    function saveSelections() {
      try {
        const handleSelections = { 1: {}, 2: {} };

        [1, 2].forEach((tab) => {
          Object.entries(selections[tab]).forEach(([variantId, qty]) => {
            const p = byVariantId.get(Number(variantId));
            if (!p) return;
            handleSelections[tab][String(p.productHandle)] = Number(qty) || 0;
          });
        });

        localStorage.setItem(
          storageKey,
          JSON.stringify({
            selections,
            handleSelections,
            activeTab
          })
        );
      } catch (e) {
        console.warn("Bundle storage save failed", e);
      }
    }

    function loadSelections() {
      try {
        const raw = localStorage.getItem(storageKey);
        if (!raw) return;

        const data = JSON.parse(raw);
        if (!data || typeof data !== "object") return;

        const nextSelections = { 1: {}, 2: {} };

        if (data.selections && typeof data.selections === "object") {
          [1, 2].forEach((tab) => {
            const map = data.selections[tab] || {};
            Object.entries(map).forEach(([variantId, qty]) => {
              const vid = Number(variantId);
              const q = Number(qty) || 0;
              if (q <= 0) return;

              if (byVariantId.has(vid)) {
                nextSelections[tab][vid] = q;
              }
            });
          });
        }

        if (data.handleSelections && typeof data.handleSelections === "object") {
          [1, 2].forEach((tab) => {
            const map = data.handleSelections[tab] || {};
            Object.entries(map).forEach(([handle, qty]) => {
              const q = Number(qty) || 0;
              if (q <= 0) return;

              const p = byHandle.get(String(handle));
              if (!p) return;

              const vid = Number(p.variantId);
              if (nextSelections[tab][vid]) return;

              nextSelections[tab][vid] = q;
            });
          });
        }

        // Kayitli secim, kural degismeden once yapilmis olabilir. Tek secimli
        // bir panele iki urunle donunce musteri elle silmek zorunda kaliyordu;
        // yuklerken kurala kirpiliyor.
        [1, 2].forEach((tab) => {
          const max = (rules[tab] && rules[tab].max) || 0;
          if (max <= 0) return;
          const ids = Object.keys(nextSelections[tab]);
          if (max === 1) {
            const keep = ids[ids.length - 1];
            const trimmed = {};
            if (keep) trimmed[keep] = 1;
            nextSelections[tab] = trimmed;
          } else {
            let total = 0;
            const trimmed = {};
            ids.forEach((vid) => {
              const q = Math.min(nextSelections[tab][vid], Math.max(0, max - total));
              if (q > 0) { trimmed[vid] = q; total += q; }
            });
            nextSelections[tab] = trimmed;
          }
        });

        selections[1] = nextSelections[1];
        selections[2] = nextSelections[2];

        if (data.activeTab) activeTab = Number(data.activeTab) || 1;
      } catch (e) {
        console.warn("Bundle storage load failed", e);
      }
    }

    function clearSelections() {
      selections[1] = {};
      selections[2] = {};

      try {
        localStorage.removeItem(storageKey);
      } catch (e) {}

      goTab(1);
      renderCounts();
      renderPicked();
      renderTotal();
      saveSelections();

      setMessage(msg.cleared);
    }

    let activeTab = 1;
    const searchQueries = { 1: "", 2: "" };

    // Mobil dokunmatik zoom için state
    let isZoomedMobile = false;
    let touchTranslateX = 0;
    let touchTranslateY = 0;
    let lastTapTime = 0;
    let lastTapX = 0;
    let lastTapY = 0;
    let lastTouchX = 0;
    let lastTouchY = 0;

    const selections = { 1: {}, 2: {} };

    const byVariantId = new Map(products.map((p) => [Number(p.variantId), p]));
    const byHandle = new Map(products.map((p) => [String(p.productHandle), p]));

    const MESSAGE_AUTO_HIDE_MS = 2500;
    let messageClearTimer = null;
    let showingTemporaryMessage = false;
    let showingPersistentError = false;
    let hasAutoExpandedForAddable = false;
    const tab1Label = sectionEl.dataset.tab1Label || "Sekme 1";
    const tab2Label = sectionEl.dataset.tab2Label || "Sekme 2";

    function formatMsg(template, vars) {
      if (!template || typeof template !== "string") return "";
      let s = template;
      Object.keys(vars || {}).forEach((k) => {
        s = s.split("{" + k + "}").join(String(vars[k] ?? ""));
      });
      return s;
    }

    const msgProductNotInTab1 =
      sectionEl.dataset.msgProductNotInTab1 ||
      "This product has no version without a Bench. Please contact our support team.";

    const msg = {
      tab1BelowMin: sectionEl.dataset.msgTab1BelowMin || "Choose at least {min} caps. Currently: {currentQty}/{min}",
      tab1Ok: sectionEl.dataset.msgTab1Ok || "Great! You have made all your cap selections {currentQty}/{max} (minimum {min})",
      tab2BelowMin: sectionEl.dataset.msgTab2BelowMin || "Now {tab2Label}. Choose at least {min} Bench. Currently: {currentQty}/{min}",
      tab2Ok: sectionEl.dataset.msgTab2Ok || "Great! You have chosen your cap. You can add {max} more Bench. {currentQty}/{max} You can add to cart now.",
      maxReached: sectionEl.dataset.msgMaxReached || "You can make at most {max} selections on this tab.",
      tab1MinAdd: sectionEl.dataset.msgTab1MinAdd || "You must make at least {min} selections on Tab 1.",
      tab2MinAdd: sectionEl.dataset.msgTab2MinAdd || "You must make at least {min} selections on Tab 2.",
      productNotFound: sectionEl.dataset.msgProductNotFound || "No product found to add to cart.",
      addedToCart: sectionEl.dataset.msgAddedToCart || "Added to cart. Redirecting you to the cart...",
      addError: sectionEl.dataset.msgAddError || "Something went wrong while adding to cart. Please try again.",
      readyAdd: sectionEl.dataset.msgReadyAdd || "All set! You can add to cart now.",
      cleared: sectionEl.dataset.msgCleared || "Selections cleared.",
      emptyPicked: sectionEl.dataset.msgEmptyPicked || "No selections yet",
      qvErrorTitle: sectionEl.dataset.msgQvErrorTitle || "Something went wrong",
      qvErrorDesc: sectionEl.dataset.msgQvErrorDesc || "Product details could not be loaded."
    };

    const MSG_COLOR_RED = "rgba(170, 8, 8, 0.95)";
    const MSG_COLOR_GREEN = "rgb(40 187 13 / 95%)";

    function updatePersistentHint() {
      if (showingTemporaryMessage || showingPersistentError) return;
      const currentQty = sumQty(selections[activeTab]);
      const { min, max } = rules[activeTab];
      const reachedMin = currentQty >= min;
      const vars = { min, max, currentQty, tab1Label, tab2Label };
      let text;
      if (activeTab === 1) {
        if (currentQty < min) {
          text = formatMsg(msg.tab1BelowMin, vars);
        } else {
          text = formatMsg(msg.tab1Ok, vars);
        }
      } else {
        if (currentQty < min) {
          text = formatMsg(msg.tab2BelowMin, vars);
        } else {
          text = formatMsg(msg.tab2Ok, vars);
        }
      }
      const color = reachedMin ? MSG_COLOR_GREEN : MSG_COLOR_RED;
      msgEls.forEach((el) => {
        el.textContent = text;
        el.style.opacity = "1";
        el.style.setProperty("color", color, "important");
      });
    }

    function setMessage(text, isError, persistent) {
      if (messageClearTimer) {
        clearTimeout(messageClearTimer);
        messageClearTimer = null;
      }
      if (!text || !String(text).trim()) {
        showingTemporaryMessage = false;
        showingPersistentError = false;
        updatePersistentHint();
        return;
      }
      showingPersistentError = !!persistent;
      showingTemporaryMessage = !persistent;
      msgEls.forEach((el) => {
        el.textContent = text;
        el.style.opacity = "1";
        el.style.color = isError ? MSG_COLOR_RED : "#000";
      });
      if (!persistent) {
        messageClearTimer = setTimeout(() => {
          messageClearTimer = null;
          showingTemporaryMessage = false;
          updatePersistentHint();
        }, MESSAGE_AUTO_HIDE_MS);
      }
    }

    function canGoNextFromTab(tab) {
      const qty = sumQty(selections[tab]);
      return qty >= rules[tab].min;
    }

    function isMaxReached(tab) {
      const qty = sumQty(selections[tab]);
      return qty >= rules[tab].max;
    }

    function canAddToCart() {
      return canGoNextFromTab(1) && sumQty(selections[2]) >= rules[2].min;
    }

    function renderTabsState() {
      tabBtns.forEach((btn) => {
        const t = Number(btn.dataset.bbTab);
        btn.classList.toggle("is-active", t === activeTab);
      });

      const tab2Btn = tabBtns.find((b) => Number(b.dataset.bbTab) === 2);
      if (tab2Btn) {
        tab2Btn.disabled = !canGoNextFromTab(1);
      }

      prevBtn.disabled = activeTab === 1;
      const textNext = sectionEl.dataset.textBtnNext || "Continue";
      const textTab2Done = sectionEl.dataset.textBtnTab2Done || "Tab 2 Done";
      nextBtn.textContent = activeTab === 1 ? textNext : textTab2Done;
      updatePersistentHint();

      reviewTabs[1].classList.toggle("is-active", activeTab === 1);
      reviewTabs[2].classList.toggle("is-active", activeTab === 2);
    }

    function renderCounts() {
      tabCounts[1].textContent = `(${sumQty(selections[1])})`;
      tabCounts[2].textContent = `(${sumQty(selections[2])})`;
    }

    function isCustomSelected() {
      if (!CUSTOM_PATCH_VARIANT_ID) return false;
      return Number((selections[2] || {})[CUSTOM_PATCH_VARIANT_ID] || 0) > 0;
    }

    /* Musteri kendi tasarimini yukleyince secim listesindeki kucuk resim de o
       olsun. Onizleme bu listeyi izliyor, boylece yuklenen gorsel ayrica bir
       baglanti kurmaya gerek kalmadan sapkanin uzerinde beliriyor. */
    function thumbFor(p) {
      if (CUSTOM_PATCH_VARIANT_ID && Number(p.variantId) === CUSTOM_PATCH_VARIANT_ID && customArtUrl) {
        return customArtUrl;
      }
      return p.image;
    }

    function showUploadError(text) {
      if (!uploadError) return;
      uploadError.textContent = text || "";
      uploadError.hidden = !text;
    }

    function clearArtwork() {
      if (customArtUrl) URL.revokeObjectURL(customArtUrl);
      customArtFile = null;
      customArtUrl = "";
      if (uploadInput) uploadInput.value = "";
      if (uploadFileEl) uploadFileEl.hidden = true;
      if (uploadThumb) uploadThumb.removeAttribute("src");
      showUploadError("");
    }

    function syncUpload() {
      if (!uploadEl) return;
      const on = isCustomSelected();
      uploadEl.hidden = !on;
      setMode(on ? "design" : "collection");
      /* Kart secimden cikarilirsa yuklenen dosya da birakilsin: aksi halde
         musteri baska bir patch secip sepete eklerken eski gorsel iliskili
         kalirdi. */
      if (!on && customArtFile) clearArtwork();
    }

    function renderPicked() {
      [1, 2].forEach((tab) => {
        const listEl = pickedEls[tab];
        const entries = Object.entries(selections[tab])
          .map(([variantId, qty]) => ({
            p: byVariantId.get(Number(variantId)),
            qty: Number(qty)
          }))
          .filter((x) => x.p && x.qty > 0);

        if (!entries.length) {
          listEl.innerHTML = `<div style="opacity:.7;font-size:13px;">${escapeHtml(msg.emptyPicked)}</div>`;
          syncUpload();
          return;
        }

        listEl.innerHTML = entries
          .map(({ p, qty }) => {
            return `
              <div class="bb__pickeditem">
                <button
                  type="button"
                  class="bb__pickedremove"
                  data-bb-picked-remove
                  data-bb-tab="${tab}"
                  data-bb-variant-id="${p.variantId}"
                  aria-label="Remove selection"
                  title="Remove"
                >×</button>

                <div class="bb__pickedleft">
                  ${
                    thumbFor(p)
                      ? `<img class="bb__pickedthumb" src="${thumbFor(p)}" alt="" loading="lazy">`
                      : `<span class="bb__pickedthumb is-empty" aria-hidden="true"></span>`
                  }
                  <span class="bb__pickedname">${escapeHtml(p.title)}</span>
                </div>

                <strong class="bb__pickedqty">x${qty}</strong>
              </div>
            `;
          })
          .join("");
      });

      /* Yukleme alani her secim degisiminde tazeleniyor: renderPicked secim
         eklendiginde, cikarildiginda ve sayfa acilirken calisan tek ortak
         nokta. */
      syncUpload();
    }

    // Önizleme fonksiyonları kaldırıldı - AI birleştirme olmadan kullanılmıyor

    function computeVisualTotalCents() {
      let total = 0;
      [1, 2].forEach((tab) => {
        Object.entries(selections[tab]).forEach(([variantId, qty]) => {
          const p = byVariantId.get(Number(variantId));
          if (!p) return;
          total += Number(p.priceCents) * Number(qty);
        });
      });
      return total;
    }

    /* Sapkanin fiyati bir patch'i zaten iceriyor: hazir "Cap with Patch" urunu
       de bos sapka da $49.90. Kurucu ikisini ayri ayri toplayip $64.80 yaziyordu,
       yani kendi tasarlayan musteri ayni seyi hazir almaya gore $14.90 fazla
       oduyordu. Sepet tarafini Shopify otomatik indirimi duzeltiyor
       (Blank Caps -> 1 patch %100, siparis basina 1); burasi yalniz onu
       ekranda aynaliyor. Bedava sayilan patch, secilenlerin EN UCUZU: boylece
       ekrandaki rakam sepetin uygulayacagindan asla dusuk cikmaz. */
    /* Sepete eklenen bir varyantin hangi panelden geldigi: kurucu disindaki
       urunler bu haritada yok, o yuzden kod yanlislikla uygulanmaz. */
    function tabOfVariant(variantId) {
      const p = byVariantId.get(Number(variantId));
      return p ? Number(p.tab) : 0;
    }

    function computeFreePatchCents() {
      if (!SET_MARKER_VARIANT_ID) return 0;
      const capCount = Object.values(selections[1] || {})
        .reduce((n, q) => n + Number(q), 0);
      if (!capCount) return 0;
      let cheapest = 0;
      Object.entries(selections[2] || {}).forEach(([variantId, qty]) => {
        if (!Number(qty)) return;
        const p = byVariantId.get(Number(variantId));
        if (!p) return;
        const cents = Number(p.priceCents);
        if (!cheapest || cents < cheapest) cheapest = cents;
      });
      return cheapest;
    }

    if (uploadInput) {
      uploadInput.addEventListener("change", () => {
        const file = uploadInput.files && uploadInput.files[0];
        if (!file) return;
        if (!/^image\/(png|jpe?g|webp)$/i.test(file.type)) {
          clearArtwork();
          showUploadError(sectionEl.dataset.uploadErrorType || "Please upload a picture.");
          return;
        }
        if (file.size > UPLOAD_MAX_BYTES) {
          clearArtwork();
          showUploadError(sectionEl.dataset.uploadErrorSize || "That picture is too large.");
          return;
        }
        if (customArtUrl) URL.revokeObjectURL(customArtUrl);
        customArtFile = file;
        customArtUrl = URL.createObjectURL(file);
        showUploadError("");
        if (uploadThumb) uploadThumb.src = customArtUrl;
        if (uploadName) uploadName.textContent = file.name;
        if (uploadFileEl) uploadFileEl.hidden = false;
        /* Secim listesini yeniden ciz: onizleme o listeyi izliyor, kucuk resim
           degisince yuklenen gorsel sapkanin uzerine kendiliginden geciyor. */
        renderPicked();
      });
    }

    if (uploadClear) {
      uploadClear.addEventListener("click", () => {
        clearArtwork();
        renderPicked();
      });
    }

    /* Mod seridi: kendi tasarimini yukleme akisini aciyor. Kategori degistirme
       mantigina dokunmuyor - gizli kategori cipinin koleksiyonuna gecip urunu
       isaretliyor, boylece secim, fiyat ve indirim yollari aynen kaliyor. */
    const modeBar = sectionEl.querySelector("[data-bb-modes]");
    const CUSTOM_HANDLE = "custom-patch";

    function setMode(mode) {
      if (!modeBar) return;
      Array.from(modeBar.querySelectorAll("[data-bb-mode]")).forEach((b) => {
        b.classList.toggle("is-active", b.getAttribute("data-bb-mode") === mode);
      });
    }

    function firstOrdinaryHandle() {
      const list = collections.filter(
        (c) => Number(c.tab) === 2 && String(c.handle) !== CUSTOM_HANDLE
      );
      return list.length ? String(list[0].handle) : "";
    }

    if (modeBar) {
      modeBar.addEventListener("click", (e) => {
        const btn = e.target.closest("[data-bb-mode]");
        if (!btn) return;
        const mode = btn.getAttribute("data-bb-mode");
        if (mode === "design") {
          onCollectionChange(CUSTOM_HANDLE, 2);
          setMode("design");
          if (CUSTOM_PATCH_VARIANT_ID && !isCustomSelected()) {
            changeQty(CUSTOM_PATCH_VARIANT_ID, 1, null, 2);
          }
          if (uploadEl) uploadEl.scrollIntoView({ block: "center" });
        } else {
          if (isCustomSelected()) changeQty(CUSTOM_PATCH_VARIANT_ID, -1, null, 2);
          const h = firstOrdinaryHandle();
          if (h) onCollectionChange(h, 2);
          setMode("collection");
        }
      });
    }

    function renderTotal() {
      const grossCents = computeVisualTotalCents();
      const freeCents = computeFreePatchCents();
      const markerCents = freeCents > 0 ? SET_MARKER_CENTS : 0;
      const selectedCents = grossCents - freeCents + markerCents;
      /* Hicbir sey secilmeden "Set total $0.00" ve simsiyah bir Sepete Ekle
         gormek bozuk izlenimi veriyor - telefonda ikisi de ilk ekranda. */
      sectionEl.classList.toggle("is-empty-selection", selectedCents === 0);

      // Discounted Total: Seçilen ürünlerin toplamı
      if (showSetTotal && setTotalEl) {
        setTotalEl.textContent = formatMoney(selectedCents, moneyFormat);
      }

      // Set Toplam: indirim varsa eski fiyat ustu cizili, yaninda odenecek tutar.
      if (showTotalPrice && totalEl) {
        const netText = formatMoney(selectedCents, moneyFormat);
        totalEl.setAttribute("data-bb-total-net", netText);
        if (freeCents > 0) {
          totalEl.innerHTML =
            '<s class="bb__wastotal">' + formatMoney(grossCents, moneyFormat) + "</s> " + netText;
        } else {
          totalEl.textContent = netText;
        }
      }
    }

    function openModal() {
      if (!modalEl) return;
      modalEl.classList.add("is-open");
      modalEl.setAttribute("aria-hidden", "false");
      modalEl.removeAttribute("inert");
      
      const interactiveElements = modalEl.querySelectorAll("button, a, input, textarea, select");
      interactiveElements.forEach((el) => {
        el.removeAttribute("tabindex");
      });
      
      document.documentElement.style.overflow = "hidden";
      document.body.style.overflow = "hidden";
    }

    function closeModal() {
      if (!modalEl) return;
      modalEl.classList.remove("is-open");
      modalEl.setAttribute("aria-hidden", "true");
      modalEl.setAttribute("inert", "");
      
      resetImageZoom();
      
      const interactiveElements = modalEl.querySelectorAll("button, a, input, textarea, select");
      interactiveElements.forEach((el) => {
        el.setAttribute("tabindex", "-1");
      });
      
      document.documentElement.style.overflow = "";
      document.body.style.overflow = "";
    }

    function setQuickViewLoading() {
      if (qvThumbsEl) qvThumbsEl.innerHTML = "";
      if (qvMainImgEl) qvMainImgEl.src = "";
      if (qvTitleEl) qvTitleEl.textContent = "Loading…";
      if (qvPriceEl) qvPriceEl.textContent = "";
      if (qvSkuEl) qvSkuEl.textContent = "";
      if (qvDescEl) qvDescEl.innerHTML = "";
      if (qvPriceCompareEl) { qvPriceCompareEl.textContent = ""; qvPriceCompareEl.style.display = "none"; }
      if (qvLinkEl) qvLinkEl.href = "#";
      resetImageZoom();
    }

    function resetImageZoom() {
      isZoomedMobile = false;
      touchTranslateX = 0;
      touchTranslateY = 0;
      if (qvModalmidEl) qvModalmidEl.classList.remove("is-touch-zoomed");
      if (qvMainImgEl) {
        qvMainImgEl.style.transform = "";
        qvMainImgEl.style.transformOrigin = "";
      }
    }

    function updateHoverZoom(e) {
      if (!qvModalmidEl || !qvMainImgEl) return;
      const rect = qvModalmidEl.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
      const xPct = (x / rect.width) * 100;
      const yPct = (y / rect.height) * 100;
      qvMainImgEl.style.transformOrigin = `${xPct}% ${yPct}%`;
      qvMainImgEl.style.transform = "scale(2.5)";
    }

    function clearHoverZoom() {
      if (!qvMainImgEl) return;
      qvMainImgEl.style.transform = "";
      qvMainImgEl.style.transformOrigin = "";
    }

    function moneyFromCents(cents) {
      return formatMoney(Number(cents), moneyFormat);
    }

    async function openQuickView(handle, variantId) {
      if (!handle) return;
      setQuickViewLoading();
      openModal();

      try {
        const res = await fetch(`/products/${handle}.js`);
        if (!res.ok) throw new Error("Could not fetch product details");
        const data = await res.json();

        if (qvTitleEl) qvTitleEl.textContent = data.title || "";

        const v =
          (data.variants || []).find((x) => Number(x.id) === Number(variantId)) ||
          (data.variants || [])[0];
        if (v) {
          if (showPopupPrices) {
            const priceCents = Number(v.price) || 0;
            const compareCents = Number(v.compare_at_price) || 0;
            const hasDiscount = compareCents > 0 && compareCents > priceCents;
            if (qvPriceEl) {
              qvPriceEl.textContent = moneyFromCents(priceCents);
              qvPriceEl.classList.toggle("bb__qvprice--sale", hasDiscount);
            }
            if (qvPriceCompareEl) {
              if (hasDiscount) {
                qvPriceCompareEl.textContent = moneyFromCents(compareCents);
                qvPriceCompareEl.style.display = "";
              } else {
                qvPriceCompareEl.textContent = "";
                qvPriceCompareEl.style.display = "none";
              }
            }
          } else {
            if (qvPriceEl) qvPriceEl.textContent = "";
            if (qvPriceCompareEl) { qvPriceCompareEl.textContent = ""; qvPriceCompareEl.style.display = "none"; }
          }
          if (qvSkuEl) qvSkuEl.textContent = v.sku ? `SKU: ${v.sku}` : "";
        } else {
          if (qvPriceEl) qvPriceEl.textContent = "";
          if (qvPriceCompareEl) { qvPriceCompareEl.textContent = ""; qvPriceCompareEl.style.display = "none"; }
          if (qvSkuEl) qvSkuEl.textContent = "";
        }

        if (qvDescEl) qvDescEl.innerHTML = data.description || "";

        // Ürün linkini set et
        if (qvLinkEl) {
          qvLinkEl.href = `/products/${handle}`;
        }

        const images = data.images || [];
        const first = images[0] || "";
        if (qvMainImgEl) qvMainImgEl.src = first;

        if (qvThumbsEl) {
          qvThumbsEl.innerHTML = images
            .map((src, i) => {
              return `<img class="bb__thumb ${i === 0 ? "is-active" : ""}" src="${src}" alt="" loading="lazy" data-bb-qv-thumb data-src="${src}">`;
            })
            .join("");
        }
      } catch (e) {
        if (qvTitleEl) qvTitleEl.textContent = msg.qvErrorTitle;
        if (qvDescEl) qvDescEl.textContent = msg.qvErrorDesc;
        console.error(e);
      }
    }
    function renderCollectionsDropdown() {
      if (!collectionsSelect) return;
      [1, 2].forEach(renderCollectionsFor);
    }

    function renderCollectionsFor(tab) {
      const items = collectionsByTab[tab] || [];
      const panelSelects = collectionsSelects.filter(
        (sel) => Number(sel.getAttribute("data-bb-panel") || 1) === tab
      );
      if (!panelSelects.length) return;

      const optHtml = (value, text, selected) => {
        const opt = document.createElement("option");
        opt.value = String(value || "").trim();
        opt.textContent = text || "—";
        if (selected) opt.selected = true;
        return opt;
      };

      if (!items.length) {
        panelSelects.forEach((sel) => {
          sel.innerHTML = "";
          sel.appendChild(optHtml("", "No collection", false));
        });
        return;
      }

      const stillExists = items.some((x) => x.handle === activeCollection[tab]);
      if (!stillExists) activeCollection[tab] = null;

      const current = activeCollection[tab] || items[0].handle;
      activeCollection[tab] = current;

      panelSelects.forEach((sel) => {
        sel.innerHTML = "";
        items.forEach((c) => {
          const handle = String(c.handle || "").trim();
          const title = (String(c.title || c.handle || "").trim()) || "—";
          sel.appendChild(optHtml(handle, title, handle === current));
        });
      });

      renderCollectionCards(tab, items, current);
    }

    /* Acilir liste yerine TR'deki gorsel secici: ikonu olan koleksiyon model
       karti, olmayan kategori cipi olarak cikar. Gizli <select> kaynak olarak
       kaliyor - erisilebilirlik ve mevcut olay akisi bozulmasin diye. */
    function renderCollectionCards(tab, items, current) {
      const wrap = sectionEl.querySelector('[data-bb-colcards][data-bb-panel="' + tab + '"]');
      if (!wrap) return;
      wrap.innerHTML = "";
      items.forEach((c) => {
        const handle = String(c.handle || "").trim();
        const label = (String(c.selectorTitle || c.title || handle || "").trim()) || "—";
        const img = String(c.image || "").trim();
        const b = document.createElement("button");
        b.type = "button";
        b.className = "bb__colcard" + (img ? " bb__colcard--icon" : "");
        b.setAttribute("role", "tab");
        b.setAttribute("data-handle", handle);
        b.setAttribute("aria-selected", handle === current ? "true" : "false");
        if (img) {
          const im = document.createElement("img");
          im.src = img;
          im.alt = "";
          im.loading = "lazy";
          b.appendChild(im);
          const sp = document.createElement("span");
          sp.textContent = label;
          b.appendChild(sp);
        } else {
          b.textContent = label;
        }
        b.addEventListener("click", () => onCollectionChange(handle, tab));
        wrap.appendChild(b);
      });
      const active = wrap.querySelector('[aria-selected="true"]');
      if (active && active.scrollIntoView) {
        active.scrollIntoView({ block: "nearest", inline: "nearest" });
      }
      updateColArrows(tab);
    }

    function updateColArrows(tab) {
      const wrap = sectionEl.querySelector('[data-bb-colcards][data-bb-panel="' + tab + '"]');
      const prev = sectionEl.querySelector('[data-bb-col-prev][data-bb-panel="' + tab + '"]');
      const next = sectionEl.querySelector('[data-bb-col-next][data-bb-panel="' + tab + '"]');
      if (!wrap) return;
      const over = wrap.scrollWidth - wrap.clientWidth;
      if (prev) prev.disabled = wrap.scrollLeft <= 2;
      if (next) next.disabled = over <= 2 || wrap.scrollLeft >= over - 2;
    }

    Array.from(sectionEl.querySelectorAll("[data-bb-col-prev], [data-bb-col-next]")).forEach((btn) => {
      const tab = Number(btn.getAttribute("data-bb-panel") || 1);
      const dir = btn.hasAttribute("data-bb-col-next") ? 1 : -1;
      btn.addEventListener("click", () => {
        const wrap = sectionEl.querySelector('[data-bb-colcards][data-bb-panel="' + tab + '"]');
        if (!wrap) return;
        wrap.scrollLeft += dir * Math.max(160, wrap.clientWidth * 0.8);
        setTimeout(() => updateColArrows(tab), 350);
      });
    });

    Array.from(sectionEl.querySelectorAll("[data-bb-colcards]")).forEach((wrap) => {
      wrap.addEventListener("scroll", () => {
        updateColArrows(Number(wrap.getAttribute("data-bb-panel") || 1));
      });
    });

    function getVisibleProducts(tab) {
      const t = Number(tab) || activeTab;
      let list = products.filter((p) => Number(p.tab) === t);

      const h = activeCollection[t];
      if (h) {
        list = list.filter((p) => String(p.collectionHandle || "") === String(h));
      }

      // Arama sorgusu varsa filtrele
      const q = searchQueries[t] || "";
      if (q && q.trim()) {
        const query = q.trim().toLowerCase();
        list = list.filter((p) => {
          const title = String(p.title || "").toLowerCase();
          return title.includes(query);
        });
      }

      // Aynı ürün birden fazla kez geldiyse (farklı kaynaklardan) tekilleştir
      const seen = new Set();
      list = list.filter((p) => {
        const vid = Number(p.variantId);
        if (!vid) return false;
        if (seen.has(vid)) return false;
        seen.add(vid);
        return true;
      });

      return list;
    }

    /* Baslikta kac urun listelendigini yaz. Arama veya koleksiyon degisince
       sayi da degisiyor, boylece filtrenin ne kadar daralttigi goruluyor. */
    function setPanelCount(tab, n) {
      const el = sectionEl.querySelector('[data-bb-panel-count="' + tab + '"]');
      if (el) el.textContent = n ? "(" + n + ")" : "";
    }

    function renderGrid() {
      setMessage("");
      [1, 2].forEach(renderGridFor);
    }

    // Ayni urun listesi tekrar basildiginda kartlari bastan yazmak yerine
    // sadece degisen seyleri (adet rozeti, buton durumu) guncelliyoruz.
    // Patch panelinde 800'den fazla kart var; her tikta innerHTML yazmak ana
    // is parcacigini yaklasik bir saniye kilitliyor ve secim gec dusuyordu.
    const lastGridSig = {};

    /* Kartin uzerindeki tek kelimelik durum. Dugme degil - kartin kendisi
       zaten dugme; bu yalniz ne olacagini soyluyor. */
    const pickLabel = sectionEl.dataset.pickLabel || "Select";
    const pickedLabel = sectionEl.dataset.pickedLabel || "Selected";

    function updateGridStates(tab, el, visible) {
      if (el.children.length !== visible.length) return false;
      const singleSelect = (rules[tab] && rules[tab].max) === 1;
      const maxReached = isMaxReached(tab);

      for (let i = 0; i < visible.length; i++) {
        const card = el.children[i];
        const p = visible[i];
        const variantId = Number(p.variantId);
        if (!card || Number(card.getAttribute("data-variant-id")) !== variantId) return false;

        const qty = selections[tab][variantId] || 0;
        const media = card.querySelector(".bb__media");
        let badge = media ? media.querySelector(".bb__qty-badge") : null;

        if (qty > 0 && media) {
          if (!badge) {
            badge = document.createElement("div");
            badge.className = "bb__qty-badge";
            badge.innerHTML = '<span class="bb__qtynum"></span>';
            const img = media.querySelector("img");
            media.insertBefore(badge, img ? img.nextSibling : media.firstChild);
          }
          badge.setAttribute("aria-label", `Quantity: ${qty}`);
          const num = badge.querySelector(".bb__qtynum");
          if (num) num.textContent = String(qty);
        } else if (badge) {
          badge.remove();
        }

        card.classList.toggle("is-selected", qty > 0);
        card.setAttribute("aria-pressed", qty > 0 ? "true" : "false");
        const pick = card.querySelector(".bb__pick");
        if (pick) pick.textContent = qty > 0 ? pickedLabel : pickLabel;
      }
      return true;
    }

    function renderGridFor(tab) {
      const el = gridEls[tab];
      if (!el) return;
      const visible = getVisibleProducts(tab);
      setPanelCount(tab, visible.length);

      if (!visible.length) {
        lastGridSig[tab] = null;
        el.innerHTML = `<div class="bb__empty" style="width:100%; padding:40px 20px; text-align:center; opacity:.6; font-size:14px;">No products found. Try a different search term.</div>`;
        return;
      }

      const sig = visible.map((p) => Number(p.variantId)).join(",");
      if (lastGridSig[tab] === sig && updateGridStates(tab, el, visible)) {
        guardCardHeight(el);
        return;
      }
      lastGridSig[tab] = sig;

      const svgMinus = '<svg class="bb__qty-svg" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M4 10h12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';
      const svgPlus = '<svg class="bb__qty-svg" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M10 4v12M4 10h12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';

      el.innerHTML = visible
        .map((p) => {
          const variantId = Number(p.variantId);
          const qty = selections[tab][variantId] || 0;
          const maxReached = isMaxReached(tab);
          const productId = p.productId ? String(p.productId) : "";

          // Tek secimli panelde "max doldu" diye diger kartlari kilitleme:
          // changeQty zaten oncekini silip yenisini koyuyor. Kilitlenirse
          // musteri once eskisini elle cikarmak zorunda kaliyordu.
          const singleSelect = (rules[tab] && rules[tab].max) === 1;
          const plusDisabled = !p.available || (singleSelect ? qty > 0 : maxReached && qty === 0);
          const minusDisabled = qty === 0;

          const priceBlock = showPrices ? (() => {
            const priceCents = Number(p.priceCents || 0);
            const compareAtPriceCents = Number(p.compareAtPriceCents || 0);
            const hasDiscount = compareAtPriceCents > 0 && compareAtPriceCents > priceCents;
            if (hasDiscount) {
              return `<p class="bb__price bb__price--current">${formatMoney(priceCents, moneyFormat)}</p><del class="bb__price-original">${formatMoney(compareAtPriceCents, moneyFormat)}</del>`;
            }
            return `<p class="bb__price bb__price--current">${formatMoney(priceCents, moneyFormat)}</p>`;
          })() : "";

          const badgeHtml = (p.badgeHtml && String(p.badgeHtml).trim()) ? p.badgeHtml : "";
          const judgeMeBadge = badgeHtml
            ? `<div class="bb__stars jdgm-widget jdgm-preview-badge">${badgeHtml}</div>`
            : "";

          return `
          <div class="bb__card${qty > 0 ? " is-selected" : ""}${!p.available ? " is-soldout" : ""}"
               data-variant-id="${variantId}"
               ${p.available ? 'role="button" tabindex="0"' : ""}
               aria-pressed="${qty > 0 ? "true" : "false"}"
               aria-label="${escapeHtml(p.title)}">
            <div class="bb__media">
              <img class="bb__img" src="${p.image || ""}" alt="${escapeHtml(p.title)}">
              ${qty > 0 ? `<div class="bb__qty-badge" aria-label="Quantity: ${qty}"><span class="bb__qtynum">${qty}</span></div>` : ""}
              ${!p.available ? '<span class="bb__stock-msg">SOLD OUT</span>' : ""}
              <button type="button" class="bb__peek" data-bb-quickview
                      data-handle="${p.productHandle}" data-variant-id="${variantId}"
                      aria-label="View product" title="View product">
                <svg viewBox="0 0 20 20" width="14" height="14" fill="none" aria-hidden="true">
                  <circle cx="8.6" cy="8.6" r="5.2" stroke="currentColor" stroke-width="1.7"/>
                  <path d="M12.7 12.7 17 17" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/>
                </svg>
              </button>
            </div>
            <div class="bb__body">
              <p class="bb__title">${escapeHtml(p.title)}</p>
              ${judgeMeBadge}
              <div class="bb__card-footer">
                <div class="bb__row bb__row--price">
                  <div class="bb__price-wrap">${priceBlock}</div>
                  <span class="bb__pick" aria-hidden="true">${qty > 0 ? pickedLabel : pickLabel}</span>
                </div>
              </div>
            </div>
          </div>
        `;
        })
        .join("");

      Array.from(el.querySelectorAll(".bb__card")).forEach((card) => {
        const variantId = Number(card.getAttribute("data-variant-id"));

        /* Kartin tamami secim. Buyutec kendi isini yapiyor, secime karismasin. */
        const toggle = (e) => {
          if (e.target.closest("[data-bb-quickview]")) return;
          if (card.classList.contains("is-soldout")) return;
          const qty = selections[tab][variantId] || 0;
          changeQty(variantId, qty > 0 ? -1 : +1, card, tab);
        };
        card.addEventListener("click", toggle);
        card.addEventListener("keydown", (e) => {
          if (e.key === "Enter" || e.key === " " || e.key === "Spacebar") {
            e.preventDefault();
            toggle(e);
          }
        });
      });

      guardCardHeight(el);
    }

    /* Izgaranin yuksekligi sinirli ve kendi icinde kayiyor. Bir tarayici
       satirlari o yukseklige sigdirmaya calisirsa kartlar birkac piksele
       iniyor ve musteri urun yerine ince seritler goruyor - iOS Safari'de
       boyle bildirildi, Chrome'da hic olmadi. CSS tarafi duzeltildi; bu
       olcum son savunma: kart yine de cokerse yukseklik siniri kaldiriliyor.
       Liste uzuyor ama urunler gorunur kaliyor.
       setTimeout kullaniliyor: requestAnimationFrame bazi gomulu tarayici
       ortamlarinda hic tetiklenmiyor. */
    const heightGuarded = new WeakSet();

    function guardCardHeight(el) {
      if (!el || heightGuarded.has(el)) return;
      setTimeout(() => {
        const card = el.querySelector(".bb__card");
        if (!card || !el.offsetParent) return;
        const box = card.getBoundingClientRect();
        if (box.width <= 0) return;              // panel gizliyse olcme
        if (box.height >= 80) return;            // her sey yolunda
        heightGuarded.add(el);
        el.style.maxBlockSize = "none";
        el.style.maxHeight = "none";
        el.style.overflowY = "visible";
        el.setAttribute("data-bb-height-guard", "1");
      }, 0);
    }

    function changeQty(variantId, delta, sourceCardEl, tab) {
      setMessage("");
      if (tab) activeTab = Number(tab);

      const p = byVariantId.get(Number(variantId));
      if (!p || !p.available) return;

      if (delta > 0 && rules[activeTab].max === 1) {
        Object.keys(selections[activeTab]).forEach((vid) => {
          if (Number(vid) !== Number(variantId)) delete selections[activeTab][vid];
        });
      }

      const current = selections[activeTab][variantId] || 0;
      const next = current + delta;

      if (next < 0) return;

      const totalBefore = sumQty(selections[activeTab]);
      const totalAfter = totalBefore + delta;

      if (delta > 0 && totalAfter > rules[activeTab].max) {
        setMessage(formatMsg(msg.maxReached, { max: rules[activeTab].max }), true);
        return;
      }

      if (next === 0) delete selections[activeTab][variantId];
      else selections[activeTab][variantId] = next;

      renderGrid();
      renderCounts();
      renderPicked();
      renderTotal();
      renderTabsState();
      saveSelections();

      // Cift panelde sekme atlama yok: iki sutun da ayni anda ekranda.

      /* Telefonda sapka secilince patch seridine kaydir. Iki serit alt alta
         duruyor; secimden sonra musteri elle asagi kaydirmak zorunda kaliyordu
         ve bir sonraki adimin ne oldugu gorunmuyordu. Masaustunde gerek yok,
         iki panel yan yana. */
      if (delta > 0 && tab === 1 && isMobileView()) {
        scrollToPanel(2);
      }

      if (delta > 0 && isMobileView() && isMaxReached(activeTab) && rules[activeTab].max > 1) {
        const alreadyOpen = sectionEl.classList.contains("is-mobile-expanded");
        if (!alreadyOpen) setMobileExpanded(true);

        if (sourceCardEl && sourceCardEl.scrollIntoView) {
          setTimeout(() => {
            sourceCardEl.scrollIntoView({ behavior: "smooth", block: "center" });
          }, 250);
        }
      }

      /* Set tamamlaninca ozet paneli kendiliginden ACILMIYOR. Panel ekranin
         ucte ikisini kapliyor ve musteri tam patch'i degistirmek isterken
         urunlerin ustunu ortuyordu. Fiyat ve Sepete Ekle kapali seritte
         duruyor; ozeti gormek isteyen serite dokunuyor. */
    }

    /* Panelin basligi yapiskan basligin altinda kalmasin diye ust bosluk
       birakiliyor. scrollIntoView yerine acik hesap: block:'start' yapiskan
       basligi hesaba katmiyor ve "Choose Your Patch" satiri gizli kaliyor. */
    function scrollToPanel(tab) {
      const grid = gridEls[tab];
      const panel = grid && grid.closest(".bb__panel");
      if (!panel) return;
      setTimeout(() => {
        const top = Math.max(panel.getBoundingClientRect().top + window.pageYOffset - 80, 0);
        const from = window.pageYOffset;
        try {
          window.scrollTo({ top: top, behavior: "smooth" });
        } catch (e) {
          window.scrollTo(0, top);
        }
        /* Yumusak kaydirma her ortamda calismiyor (bazi gomulu tarayicilar ve
           "hareketi azalt" ayari sessizce yok sayiyor). Yerinden kimildamadiysa
           duz kaydiriyoruz - kaydirmanin kendisi davranisin ta kendisi. */
        setTimeout(() => {
          if (Math.abs(window.pageYOffset - from) < 4 && Math.abs(top - from) > 8) {
            window.scrollTo(0, top);
          }
        }, 400);
      }, 120);
    }

    function goTab(tab) {
      activeTab = tab;
      // Tab değişince arama sorgusunu temizle
      if (searchInput) searchInput.value = "";
      searchQueries[1] = "";
      searchQueries[2] = "";
      renderCollectionsDropdown();
      renderGrid();
      renderTabsState();
      saveSelections();

      if (tab === 2) {
        sectionEl.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }


    async function addToCart() {
      setMessage("");

      if (!canGoNextFromTab(1)) {
        setMessage(formatMsg(msg.tab1MinAdd, { min: rules[1].min }), true);
        goTab(1);
        return;
      }
      if (sumQty(selections[2]) < rules[2].min) {
        setMessage(formatMsg(msg.tab2MinAdd, { min: rules[2].min }), true);
        goTab(2);
        return;
      }

      // Seçilen tüm ürünleri topla
      // Tab 1 seçimlerini en son ekle ki sepette en üstte görünsün
      const itemsToAdd = [];
      [2, 1].forEach((tab) => {
        Object.entries(selections[tab]).forEach(([variantId, qty]) => {
          const p = byVariantId.get(Number(variantId));
          if (!p || !qty || qty <= 0) return;
          itemsToAdd.push({
            id: Number(variantId),
            quantity: Number(qty)
          });
        });
      });

      if (itemsToAdd.length === 0) {
        setMessage(msg.productNotFound, true);
        return;
      }

      /* Kendi tasarimi secilip gorsel yuklenmediyse durdur: siparise ne
         basilacagi belli olmadan sepete gitmesin. */
      if (isCustomSelected() && !customArtFile) {
        setMessage(sectionEl.dataset.uploadMissing || "Upload your design first.", true);
        if (uploadEl) uploadEl.scrollIntoView({ block: "center" });
        return;
      }

      /* Sapkanin fiyati bir patch'i zaten iceriyor. Isaret satiri yalniz ikisi
         birden secildiginde ekleniyor; indirim de yalniz o satir sepetteyken
         calisiyor. */
      const boughtCap = itemsToAdd.some((it) => tabOfVariant(it.id) === 1);
      const boughtPatch = itemsToAdd.some((it) => tabOfVariant(it.id) === 2);
      if (SET_MARKER_VARIANT_ID && boughtCap && boughtPatch) {
        itemsToAdd.push({ id: SET_MARKER_VARIANT_ID, quantity: 1 });
      }

      addBtn.disabled = true;
      addBtn.textContent = ADDING_LABEL;

      try {
        /* Dosya JSON govdesiyle gonderilemiyor, multipart gerekiyor; o yuzden
           kendi tasarimi ayri bir istekle ekleniyor. Once sapka ve isaret
           satiri gitsin ki sepette ustte dursunlar. */
        const customItems = itemsToAdd.filter((it) => it.id === CUSTOM_PATCH_VARIANT_ID);
        const plainItems = itemsToAdd.filter((it) => it.id !== CUSTOM_PATCH_VARIANT_ID);

        if (plainItems.length) {
          const res = await fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ items: plainItems })
          });
          if (!res.ok) {
            const txt = await res.text();
            throw new Error(txt || "Cart add failed");
          }
        }

        if (customItems.length && customArtFile) {
          const fd = new FormData();
          fd.append("id", String(customItems[0].id));
          fd.append("quantity", String(customItems[0].quantity));
          fd.append("properties[Your design]", customArtFile, customArtFile.name);
          const res2 = await fetch("/cart/add.js", { method: "POST", body: fd });
          if (!res2.ok) {
            const txt = await res2.text();
            throw new Error(txt || "Cart add failed");
          }
        }

        setMessage(msg.addedToCart);
        window.location.href = "/cart";
      } catch (e) {
        console.error(e);
        setMessage(msg.addError, true);
      } finally {
        addBtn.disabled = false;
        addBtn.textContent = "Add to cart";
      }
    }

    tabBtns.forEach((btn) => {
      btn.addEventListener("click", () => {
        const t = Number(btn.dataset.bbTab);
        if (t === 2 && !canGoNextFromTab(1)) return;
        goTab(t);
      });
    });

    prevBtn.addEventListener("click", () => goTab(1));

    nextBtn.addEventListener("click", () => {
      if (activeTab === 1) {
        if (!canGoNextFromTab(1)) {
          setMessage(formatMsg(msg.tab1MinAdd, { min: rules[1].min }), true);
          return;
        }
        goTab(2);
      } else {
        if (sumQty(selections[2]) < rules[2].min) {
          setMessage(formatMsg(msg.tab2MinAdd, { min: rules[2].min }), true);
          return;
        }
        setMessage(msg.readyAdd);
      }
    });

    clearBtn.addEventListener("click", clearSelections);

    [1, 2].forEach((tab) => {
      const listEl = pickedEls[tab];
      listEl.addEventListener("click", (e) => {
        const btn = e.target.closest("[data-bb-picked-remove]");
        if (!btn) return;

        const t = Number(btn.dataset.bbTab);
        const variantId = Number(btn.dataset.bbVariantId);

        if (!t || !variantId) return;

        delete selections[t][variantId];

      renderGrid();
      renderCounts();
      renderPicked();
      renderTotal();
      renderTabsState();

        saveSelections();
      });
    });

    addBtn.addEventListener("click", addToCart);

    function handleQuickViewTrigger(el) {
      if (!el) return;
      const handle = el.getAttribute("data-handle");
      const variantId = Number(el.getAttribute("data-variant-id"));
      openQuickView(handle, variantId);
    }

    allGrids.forEach((g) => {
      g.addEventListener("click", (e) => {
        const btn = e.target.closest("[data-bb-quickview]");
        if (!btn) return;
        e.preventDefault();
        e.stopPropagation();
        handleQuickViewTrigger(btn);
      });

      g.addEventListener("keydown", (e) => {
        const btn = e.target.closest("[data-bb-quickview]");
        if (!btn || (e.key !== "Enter" && e.key !== " ")) return;
        e.preventDefault();
        handleQuickViewTrigger(btn);
      });
    });

    modalCloseEls && modalCloseEls.forEach((el) => {
      el.addEventListener("click", (e) => { e.stopPropagation(); closeModal(); });
    });

    /* Modal dışına (blur alanına) tıklanınca kapat */
    if (modalEl) {
      modalEl.addEventListener("click", (e) => {
        if (!modalEl.classList.contains("is-open")) return;
        if (e.target === modalEl || e.target.classList.contains("bb__modalbackdrop")) {
          closeModal();
        }
      });
      document.addEventListener("keydown", (e) => {
        if (e.key === "Escape" && modalEl.classList.contains("is-open")) {
          closeModal();
        }
      });
    }

    if (qvThumbsEl) {
      qvThumbsEl.addEventListener("click", (e) => {
        const t = e.target.closest("[data-bb-qv-thumb]");
        if (!t) return;
        const src = t.getAttribute("data-src");
        if (qvMainImgEl && src) qvMainImgEl.src = src;

        qvThumbsEl.querySelectorAll(".bb__thumb").forEach((x) => x.classList.remove("is-active"));
        t.classList.add("is-active");
        
        resetImageZoom();
      });
    }

    // Fare ile üzerine gelince yakınlaştırma, hareketle farklı yerlere bakma (masaüstü)
    // Mobil: çift dokunma ile yakınlaştır, elle kaydırarak incele
    const hasTouch = "ontouchstart" in window;
    if (qvModalmidEl) {
      if (!hasTouch) {
        qvModalmidEl.addEventListener("mouseenter", (e) => updateHoverZoom(e));
        qvModalmidEl.addEventListener("mousemove", (e) => updateHoverZoom(e));
        qvModalmidEl.addEventListener("mouseleave", clearHoverZoom);
      } else {
        qvModalmidEl.addEventListener("touchstart", (e) => {
          if (!e.touches.length) return;
          const x = e.touches[0].clientX;
          const y = e.touches[0].clientY;
          const now = Date.now();
          const isDoubleTap = (now - lastTapTime) < 400 && Math.abs(x - lastTapX) < 40 && Math.abs(y - lastTapY) < 40;
          if (isZoomedMobile) {
            if (isDoubleTap) {
              resetImageZoom();
              lastTapTime = 0;
              lastTapX = 0;
              lastTapY = 0;
              return;
            }
            lastTouchX = x;
            lastTouchY = y;
            lastTapTime = now;
            lastTapX = x;
            lastTapY = y;
          } else {
            if (isDoubleTap) {
              isZoomedMobile = true;
              touchTranslateX = 0;
              touchTranslateY = 0;
              if (qvModalmidEl) qvModalmidEl.classList.add("is-touch-zoomed");
              if (qvMainImgEl) {
                qvMainImgEl.style.transformOrigin = "50% 50%";
                qvMainImgEl.style.transform = "translate(0px, 0px) scale(2.5)";
              }
            }
            lastTapTime = now;
            lastTapX = x;
            lastTapY = y;
          }
        }, { passive: true });
        qvModalmidEl.addEventListener("touchmove", (e) => {
          if (!isZoomedMobile || !e.touches.length || !qvMainImgEl) return;
          e.preventDefault();
          const rect = qvModalmidEl.getBoundingClientRect();
          const dx = e.touches[0].clientX - lastTouchX;
          const dy = e.touches[0].clientY - lastTouchY;
          touchTranslateX += dx;
          touchTranslateY += dy;
          const maxX = Math.max(rect.width * 0.5, 60);
          const maxY = Math.max(rect.height * 0.5, 60);
          touchTranslateX = Math.max(-maxX, Math.min(maxX, touchTranslateX));
          touchTranslateY = Math.max(-maxY, Math.min(maxY, touchTranslateY));
          lastTouchX = e.touches[0].clientX;
          lastTouchY = e.touches[0].clientY;
          qvMainImgEl.style.transform = `translate(${touchTranslateX}px, ${touchTranslateY}px) scale(2.5)`;
        }, { passive: false });
      }
    }

    function setMobileExpanded(expanded) {
      sectionEl.classList.toggle("is-mobile-expanded", !!expanded);
      
      // Mobil başlık
      if (reviewHeadEl) {
        reviewHeadEl.setAttribute("aria-expanded", expanded ? "true" : "false");
      }
      if (reviewTitleTextEl) {
        reviewTitleTextEl.textContent = expanded ? "Hide your selections" : "See your selections";
      }
      if (reviewTitleIconEl) {
        reviewTitleIconEl.textContent = expanded ? "▼" : "▲";
      }
    }

    function isMobileView() {
      if (!window.matchMedia) return false;
      return window.matchMedia("(max-width: 768px)").matches ||
             window.matchMedia("(max-width: 1024px) and (orientation: portrait)").matches;
    }

    if (reviewHeadEl) {
      reviewHeadEl.addEventListener("click", () => {
        if (!isMobileView()) return;
        const willExpand = !sectionEl.classList.contains("is-mobile-expanded");
        setMobileExpanded(willExpand);
      });
      reviewHeadEl.addEventListener("keydown", (e) => {
        if (!isMobileView()) return;
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          const willExpand = !sectionEl.classList.contains("is-mobile-expanded");
          setMobileExpanded(willExpand);
        }
      });
    }

    function onCollectionChange(value, tab) {
      const t = Number(tab) || activeTab;
      activeCollection[t] = value;
      collectionsSelects
        .filter((sel) => Number(sel.getAttribute("data-bb-panel") || 1) === t)
        .forEach((sel) => { if (sel.value !== value) sel.value = value; });
      const cardWrap = sectionEl.querySelector('[data-bb-colcards][data-bb-panel="' + t + '"]');
      if (cardWrap) {
        Array.from(cardWrap.querySelectorAll(".bb__colcard")).forEach((b) => {
          b.setAttribute("aria-selected", b.getAttribute("data-handle") === value ? "true" : "false");
        });
      }
      renderGrid();
      renderTabsState();
      updatePersistentHint();
    }

    collectionsSelects.forEach((sel) => {
      sel.addEventListener("change", (e) => {
        onCollectionChange(e.target.value, Number(sel.getAttribute("data-bb-panel") || 1));
      });
    });

    // Panel basina arama kutusu: TR'de her sutunun kendi aramasi var.
    Array.from(sectionEl.querySelectorAll("[data-bb-panel-search]")).forEach((inp) => {
      const tab = Number(inp.getAttribute("data-bb-panel") || 1);
      inp.addEventListener("input", (e) => {
        searchQueries[tab] = e.target.value || "";
        renderGridFor(tab);
      });
    });

    let searchClickOutsideHandler = null;

    function toggleSearch(expanded) {
      if (!searchEl) return;
      const isMobile = isMobileView();
      
      if (expanded) {
        searchEl.classList.remove("is-collapsed");
        searchEl.classList.add("is-expanded");
        if (searchInput) {
          setTimeout(() => searchInput.focus(), 300);
        }
        
        // Mobil / tablet portrait'ta click outside listener ekle
        if (isMobile && searchWrapper) {
          if (searchClickOutsideHandler) {
            document.removeEventListener("click", searchClickOutsideHandler);
          }
          searchClickOutsideHandler = (e) => {
            if (searchEl.classList.contains("is-expanded")) {
              if (!searchWrapper.contains(e.target) && searchToggle && !searchToggle.contains(e.target)) {
                toggleSearch(false);
                searchQueries[activeTab] = "";
                if (searchInput) searchInput.value = "";
                renderGrid();
              }
            }
          };
          setTimeout(() => {
            document.addEventListener("click", searchClickOutsideHandler);
          }, 100);
        }
      } else {
        searchEl.classList.remove("is-expanded");
        searchEl.classList.add("is-collapsed");
        
        // Click outside listener'ı temizle
        if (searchClickOutsideHandler) {
          document.removeEventListener("click", searchClickOutsideHandler);
          searchClickOutsideHandler = null;
        }
      }
    }

    if (searchToggle && searchEl) {
      // Mobil / tablet portrait'ta başlangıçta kapalı - input kapalı ama ikon görünür
      const checkMobile = () => isMobileView();
      
      let wasMobile = checkMobile();
      
      // Sayfa yüklendiğinde mobil kontrolü yap (sadece ilk yüklemede)
      if (wasMobile) {
        searchEl.classList.add("is-collapsed");
        searchEl.classList.remove("is-expanded");
      } else {
        // Desktop'ta class'ları temizle
        searchEl.classList.remove("is-collapsed");
        searchEl.classList.remove("is-expanded");
      }

      // Resize'da sadece mobil/desktop geçişi varsa kontrol et (debounce ile)
      let resizeTimeout = null;
      window.addEventListener("resize", () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
          const isMobile = checkMobile();
          // Sadece mobil/desktop geçişi olduğunda class'ları güncelle
          if (isMobile !== wasMobile) {
            wasMobile = isMobile;
            if (isMobile) {
              // Mobilde geçiş - eğer açık değilse kapalı yap (açıksa açık bırak)
              if (!searchEl.classList.contains("is-expanded")) {
                searchEl.classList.add("is-collapsed");
                searchEl.classList.remove("is-expanded");
              }
            } else {
              // Desktop'a geçiş - class'ları temizle
              if (searchClickOutsideHandler) {
                document.removeEventListener("click", searchClickOutsideHandler);
                searchClickOutsideHandler = null;
              }
              searchEl.classList.remove("is-collapsed");
              searchEl.classList.remove("is-expanded");
            }
          }
        }, 150);
      });

      searchToggle.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        const isExpanded = searchEl.classList.contains("is-expanded");
        toggleSearch(!isExpanded);
      });
    }

    if (searchInput) {
      searchInput.addEventListener("input", (e) => {
        searchQueries[activeTab] = e.target.value || "";
        renderGrid();
      });

    }

    loadSelections();
    renderCollectionsDropdown();
    renderGrid();
    renderCounts();
    renderPicked();
    renderTotal();
    renderTabsState();
    saveSelections();

    /* Ilk cizim Liquid'in verdigi ilk 50 urunle yapiliyor, sayfa hemen
       kullanilabilir oluyor; kalan urunler arkadan geliyor ve izgara
       kendini yeniliyor. */
    setTimeout(() => {
      loadRestOfCollections().catch(() => {});
    }, 60);

    // URL'den ?model=A-7500-141428 parametresini kontrol et - Choose model'teki TÜM koleksiyonlarda ara
    const urlParams = new URLSearchParams(window.location.search);
    const modelFromUrl = (urlParams.get("model") || urlParams.get("sku") || "").trim();
    if (modelFromUrl) {
      const tab1Products = products.filter((p) => Number(p.tab) === 1);
      const model = String(modelFromUrl);
      const matchingProduct = tab1Products.find((p) => {
        const sku = String(p.sku || "");
        return sku === model || sku.startsWith(model + "-");
      });
      if (matchingProduct && matchingProduct.available) {
        const variantId = Number(matchingProduct.variantId);
        const qty = rules[1].min || 1;
        selections[1][variantId] = qty;
        if (matchingProduct.collectionHandle) {
          activeCollection[1] = String(matchingProduct.collectionHandle);
        }
        activeTab = 2;
        renderCollectionsDropdown();
        renderGrid();
        renderCounts();
        renderPicked();
        renderTotal();
        renderTabsState();
        saveSelections();
        /* Urun sayfasindaki "Buy this one with a different Patch" baglantisi
           buraya ?model= ile geliyor. Sapka zaten secili; musterinin isi
           patch secmek, o yuzden sayfa dogrudan 2. adima iniyor. Aksi halde
           sayfanin tepesinde acilip yeniden sapka seciyormus gibi
           gorunuyordu. Kaydirma ilk cizimden sonra yapiliyor. */
        setTimeout(function () { scrollToPanel(2); }, 250);
      } else {
        activeTab = 1;
        renderCollectionsDropdown();
        renderGrid();
        renderTabsState();
        setMessage(msgProductNotInTab1, true, true);
      }
    }

    /* Sayfa acilirken ozet paneli kendiliginden ACILMIYOR. Onceki secim
       localStorage'dan geri yuklendiginde panel aciliyor ve 812px'lik ekranin
       498px'ini kapliyordu: musteri sayfaya girer girmez urun yerine ozet
       goruyordu. Fiyat ve Sepete Ekle artik kapali seritte de durdugu icin
       paneli acmaya gerek yok. */
  }

  function escapeHtml(str) {
    return String(str || "")
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;");
  }

  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".bb[data-section-id]").forEach(initBundleBuilder);
  });
})();
